import { createReducer, on } from '@ngrx/store';
import { ClientType } from 'src/app/back-office/clients-accounts/client-type';
import { AppState } from '../app.state';
import { clear, updateAllState } from './user.action';

export const initialState: AppState = {
  user: { client: '', clientType: ClientType.SmartBuilding },
};

export const userReducer = createReducer(
  initialState,
  on(updateAllState, (state, { user }) => ({
    ...state,
    user,
  })),
  on(clear, (state) => initialState)
);
